import { api } from "./client";

export type InboxItemType =
  | "metric_alert"
  | "approval"
  | "issue"
  | "pj_escalation"
  | "work_item"
  | "work_item_approval";

export type InboxSeverity = "critical" | "warning" | "info";

export type InboxItemAction =
  | { kind: "graph_resume"; graphId: string; runId: string; itemId: string }
  | { kind: "work_item_dismiss"; itemId: string };

export interface InboxItem {
  id: string;
  sourceId: string;
  type: InboxItemType;
  title: string;
  subtitle: string | null;
  severity: InboxSeverity;
  status: string;
  unread: boolean;
  timestamp: string;
  link: string | null;
  action?: InboxItemAction;
}

export const inboxApi = {
  list: (companyId: string, opts?: { filter?: "unread" | "all"; limit?: number }) => {
    const params = new URLSearchParams();
    if (opts?.filter) params.set("filter", opts.filter);
    if (opts?.limit) params.set("limit", String(opts.limit));
    const qs = params.toString();
    return api.get<InboxItem[]>(`/companies/${companyId}/inbox${qs ? `?${qs}` : ""}`);
  },
  count: (companyId: string) =>
    api.get<{ count: number }>(`/companies/${companyId}/inbox/count`),
};
